export default {
	home: {
		name: ""
	},
	page_out_trade_no: "加盟店注文番号",
	_start_recording: "録画開始",
	_stop_recording: "録画停止",
	_switch_obj: "OBJに切り替え",
	_switch_gaussian: "Gaussianに切り替え",
	_switch_glb: "GLBに切り替え",
	_model_does_not_exist: "モデルファイルが存在しません",
	"_no_photos!": "写真がありません",
	_image_loading_failed: "画像の読み込みに失敗しました",
	_no_gaussian_model_available: "Gaussianモデルがありません",
	_no_normal_map_available: "モデルの法線マップがありません",
	"_model_loading_failed,_please_try_again_later":
		"モデルの読み込みに失敗しました。後でもう一度お試しください",
	"_obj_model_does_not_exist,_automatically_switched_to_gaussian_preview":
		"OBJモデルが存在しないため、Gaussianプレビューに自動で切り替えました",
	_original_uploaded_photo: "元のアップロード写真",
	_effect_image: "効果画像",
	submit_modeling_model_file_not_ready:
		"モデルファイルの準備がまだできていません。しばらくしてから再試行するか、カスタマーサポートにお問い合わせください。",
	finance_package_order_reverse: "パッケージ定額逆仕訳",
	finance_shop_red_reversal: "店舗逆仕訳",
	finance_dealer_red_reversal: "ディーラー逆仕訳"
};
